<script>
import formatDate from '@utils/format-date'
import { DATE_TIME_FORMAT_SPACING } from '@utils/constant'
export default {
  props: {
    date: {
      type: String,
      default: '',
      require: true,
    },
  },
  computed: {
    formatDateComputed() {
      if (!this.date) {
        return this.date
      }
      return formatDate(this.date, DATE_TIME_FORMAT_SPACING)
    },
  },
}
</script>

<template>
  <div id="date-time-format-on-table">
    {{ formatDateComputed }}
  </div>
</template>

<style lang="scss" scoped>
#date-time-format-on-table {
  white-space: pre;
}
</style>
